import { conditionalString } from '@silverhand/essentials';
import classNames from 'classnames';
import i18next from 'i18next';
import { useContext } from 'react';
import { Helmet } from 'react-helmet';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import { getWechatBindingPresentation } from '@/components/WechatSignIn/presentation';
import { getContextualSignInPage } from '@/utils/contextual-sign-in-page';

import styles from './index.module.scss';

/**
 * User React Helmet to manage html and body attributes
 * @see https://github.com/nfl/react-helmet
 *
 * - lang: set html lang attribute
 * - data-theme: set html data-theme attribute
 * - favicon: set favicon
 * - apple-touch-icon: set apple touch icon
 * - body class: set preview body class
 * - body class: set platform body class
 * - body class: set theme body class
 * - custom css: set custom css style tag
 */

const AppMeta = () => {
  const { experienceSettings, theme, platform, isPreview } = useContext(PageContext);

  return (
    <Helmet>
      <html
        lang={i18next.language}
        dir={i18next.dir()}
        data-theme={theme}
        data-contextual-sign-in={
          (getContextualSignInPage() ?? getWechatBindingPresentation()) ? 'true' : undefined
        }
      />
      <link rel="icon" type="image/png" sizes="32x32" href="/assets/vibehub-favicon-32.png" />
      <link rel="icon" type="image/svg+xml" sizes="any" href="/assets/vibehub-favicon.svg" />
      <link rel="apple-touch-icon" sizes="180x180" href="/assets/vibehub-apple-touch-icon.png" />
      {experienceSettings?.customCss && <style>{experienceSettings.customCss}</style>}
      <body
        className={classNames(
          conditionalString(isPreview && styles.preview),
          platform === 'mobile' ? 'mobile' : 'desktop',
          conditionalString(styles[theme])
        )}
      />
    </Helmet>
  );
};

export default AppMeta;
